import React from "react";

import { Grid, TextField, Button, Typography } from "@material-ui/core";
import { StoreState } from "common/store/types";
import { useHistory } from "react-router";
import { User } from "common/store/user/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import "./CustomerInfo.scss";

export const CustomerInfo = ({ variant }: any) => {
  //Hooks
  const currentUser = useSelector<StoreState, User>(
    (state) => state.currentUser
  );

  if (variant === "secondary") {
    return <CustomerInfoSecondary user={currentUser} />;
  } else {
    return <CustomerInfoPrimary user={currentUser} />;
  }
};

const CustomerInfoPrimary = ({ user }: any) => {
  //Hooks
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="section--nested">
      <Typography className="section-title--big" variant="subtitle1">
        {t("Customer Info")}
      </Typography>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled
            label={t("First name")}
            value={user.firstName}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            disabled
            label={t("Last name")}
            value={user.lastName}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            disabled
            label={t("Address")}
            value={user.address}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}></Grid>

        <Grid item>
          <Button
            className="primary"
            onClick={() => history.push("/personal-data")}
            style={{}}
            fullWidth
            variant="contained"
          >
            {t("Edit")}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

const CustomerInfoSecondary = ({ user }: any) => {
  return (
    <div className="customer-info">
      <Typography className="title" variant="subtitle1">
        {user.firstName} {user.lastName}
      </Typography>
      <div className="user-item">{user.email}</div>
      <div className="user-item">{user.cellphone}</div>
      <div className="user-item">
        {user.address}, {user.addressZipcode},{user.addressCity},{" "}
        {
          //TODO(Marko): Get county name using addressCountry
          user.addressCountry
        }
      </div>
    </div>
  );
};
